export default __webpack_public_path__ + "static/media/no-image-user.4dd972ba.jpeg";